@let currentRealisation = realisation();
@let currentForm = form();
@let isMarkedForRemoval = !!currentForm.controls.removed.value;
@let isTimeEditor = Functionalities.HourTimeEdit | hasFunctionality;

@if (!isTimeEditor || canApproveHours) {
    <div
        class="toggles d-flex flex-shrink-0 curpoint"
        [class.pe-none]="notApprovable() || notEditable() || (isMarkedForRemoval && currentRealisation.approved)">
        @if (!isTimeEditor) {
            <div
                class="toggle d-flex flex-shrink-0 align-items-center justify-content-center"
                [class.checked]="currentForm.value?.skip_performer && currentForm.value?.comment_manager"
                (click)="skipPerformer($event)">
                <i class="fa-regular fa-question lh-1"></i>
            </div>
        }

        @if (canApproveHours) {
            @if (currentRealisation.comment_user_approved) {
                <div
                    class="toggle d-flex flex-shrink-0 align-items-center justify-content-center"
                    [class.checked]="currentForm.value?.comment_user_approved_handled"
                    (click)="approve($event)">
                    <i class="fa-regular fa-check lh-1"></i>
                </div>
            } @else {
                <div
                    class="toggle d-flex flex-shrink-0 align-items-center justify-content-center"
                    [class.checked]="currentForm.value?.approved"
                    (click)="approve($event)">
                    <i class="fa-regular fa-check lh-1"></i>
                </div>
            }
        }
    </div>
}

<button
    class="comment planning-button"
    [class.pe-none]="notEditable() || (isMarkedForRemoval && currentRealisation.approved)"
    [disabled]="currentForm.disabled"
    (click)="isTimeEditor ? editComment($event, 'comment_user') : skipPerformer($event)"
    mat-icon-button
    color="primary">
    <mat-icon fontSet="fas" fontIcon="fa-comment"></mat-icon>
</button>

@if (isMarkedForRemoval) {
    <button
        class="remove planning-button"
        [class.pe-none]="notEditable()"
        [disabled]="currentForm.disabled"
        (click)="restore($event)"
        mat-icon-button
        color="primary">
        <mat-icon fontSet="fas" fontIcon="fa-trash-undo"></mat-icon>
    </button>
} @else {
    <button
        class="remove planning-button"
        [class.pe-none]="notEditable()"
        [disabled]="currentForm.disabled"
        (click)="remove($event)"
        mat-icon-button
        color="primary">
        <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
    </button>
}

@if (Functionalities.CommonHourCheck | hasFunctionality) {
    <button class="history planning-button" (click)="showHistory($event)" mat-icon-button color="primary">
        <mat-icon fontSet="fas" fontIcon="fa-history"></mat-icon>
    </button>
}
